<template>
  <div>
    <v-card>
      <img ref="qrcode"/>
      <v-card-text>
        <v-text-field v-model="value" :readonly="readonly" />
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>

</style>

<script>
import QrcodeInput from "./qrcodeInput.ts";
export default QrcodeInput;
</script>